import {COLORS, Countdown} from '@aboutyou/ui-components';
import React, {ComponentProps} from 'react';
import styled, {css} from 'styled-components';
import {CouponExpiryDateCountdownIcon} from './CouponExpiryDateCountdownIcon';
import {CouponExpiryDateCountdownUnitComponent} from './CouponExpiryDateCountdownUnitComponent';

interface CouponExpiryDateCountdownProps {
  expiryDate: Date;
  className?: string;
  iconSize?: ComponentProps<typeof CouponExpiryDateCountdownIcon>['size'];
  preventUnitComponentEqualWidth?: boolean;
}

export const CouponExpiryDateCountdown = ({
  expiryDate,
  className,
  iconSize = 'S',
  preventUnitComponentEqualWidth,
  ref,
}: CouponExpiryDateCountdownProps & {ref?: React.Ref<HTMLDivElement>}) => {
  return (
    <Container className={className} ref={ref}>
      <StyledCouponExpiryDateCountdownIcon size={iconSize} />

      <StyledCountdown
        endDate={expiryDate}
        $preventUnitComponentEqualWidth={preventUnitComponentEqualWidth}
        unitComponent={StyledCouponExpiryDateCountdownUnitComponent}
      />
    </Container>
  );
};

export const StyledCouponExpiryDateCountdownIcon = styled(
  CouponExpiryDateCountdownIcon,
)``;

const Container = styled.div<{$isHotDeal?: boolean}>`
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 3px 18px;
  border-radius: 26px;
  border: 1px solid rgba(21, 57, 207, 0.4);
  background-color: ${COLORS.White};
`;

export const StyledCouponExpiryDateCountdownUnitComponent = styled(
  CouponExpiryDateCountdownUnitComponent,
)`
  width: 33.33%;
  // gap is not working when length of element is overflowing.
  // That is mostly impacting days or larger units
  &:not(:last-child) {
    margin-right: 6px;
  }
`;

const StyledCountdown = styled(Countdown)<{
  $preventUnitComponentEqualWidth?: boolean;
}>`
  && {
    padding: 0;
  }

  ${({$preventUnitComponentEqualWidth}) =>
    $preventUnitComponentEqualWidth &&
    css`
      ${StyledCouponExpiryDateCountdownUnitComponent} {
        width: auto;
      }
    `}
`;
